import type { SharedHomeWidget, WidgetLock } from 'types/homeWidgetSharing';
import type { HomeWidgetSize } from 'types/homeWidgets';
import { KpiWidget } from './kpi/KpiWidget';
import { LockPanel } from './share/LockPanel';
import { WidgetMenu } from './WidgetMenu';

type Props = {
    widget: SharedHomeWidget;
    /** The size its entry gives it on Home, which can differ from the one its author chose. */
    size: HomeWidgetSize;
    /** Set on a widget the firm put on this Home: it then has no menu, and says why it is there instead. */
    lock?: WidgetLock;
};

/**
 * A widget somebody built, on Home: its card, with its figure, and at the end of the header its menu, or its lock
 * when the firm placed it.
 */
export function WidgetHost({ widget, size, lock }: Props) {
    return (
        <KpiWidget
            widget={widget}
            size={size}
            // The guided tour points at a widget the person built, never at one the firm placed.
            data-tour={lock ? undefined : 'home-widget'}
            actions={lock ? <LockPanel name={widget.name} lock={lock} /> : <WidgetMenu widget={widget} size={size} />}
        />
    );
}
